import { FC } from 'react';

import { ComboInCart } from '../../../types/cart';
import { Ticket } from '../../../types/ticket';
import SelectedTicket from './SelectedTicket';
import * as Styles from './summary.styles';

export type TicketCart = {
  price: number;
  originalPrice: number;
  quantity: number;
  group: string;
  title: string;
  date: string;
  accumulatedValueInCart: number;
  definitiveSessionId: string;
} & Ticket;

type SelectedTicketsProps = {
  tickets: TicketCart[];
  combosInCart: ComboInCart[];
}

const SelectedTickets: FC<SelectedTicketsProps> = ({ tickets, combosInCart }) => {
  const hasCombo = combosInCart.length > 0;

  return (
    <Styles.SelectedTickets id='selected-tickets-container'>
      {hasCombo && combosInCart.map((combo, index) => (
        <SelectedTicket key={index} combo={combo} index={index} isCombo />
      ))}
      {tickets.map((ticket, index) => (
        <SelectedTicket key={index} ticket={ticket} index={index} />
      ))}
    </Styles.SelectedTickets>
  );
};

export default SelectedTickets;
